import { ExplorerContentSplit, ExplorerUserContent, Item } from '../../../domain/newExplorers';

export const splitContentAndItemsToExplorerContent = (
  contents: ExplorerContentSplit,
  item: Item
): ExplorerUserContent => contents[`${item.type}s`].find(({ content: { _id } }) => _id === item.id);
